import React from "react";
import ProfileTitle from "../../components/ProfileTitle";
import Styles from "../platform-pages/admin/sys-site/site.module.css";
import {Button, Form, Input, message, Switch} from "antd";
import {useRequest} from "ahooks";
import * as api from "../../apis/apiConfig";


function ExternalConfig(props: { system: string }) {

    const [form] = Form.useForm()

    useRequest(api.getExternalApiConfiguration, {
        defaultParams: [props.system],
        onSuccess: response => {
            form.setFieldsValue(response.data.data)
        }
    })

    const {run, loading} = useRequest(api.modifyExternalApiConfiguration, {
        manual: true,
        onSuccess: () => {
            message.success("保存成功")
        }
    })

    return (
        <div>
            <ProfileTitle>站点配置</ProfileTitle>
            <div className={Styles.container}>
                <Form form={form} layout={"vertical"} style={{width: 300}}
                      onFinish={values => run({...values, sysName: props.system})}>
                    <Form.Item noStyle name={'id'}>
                        <Input style={{display: 'none'}}/>
                    </Form.Item>
                    <Form.Item label={'是否启用'} name={'enable'} valuePropName={'checked'}>
                        <Switch/>
                    </Form.Item>
                    <Form.Item label={'接口地址'} name={'url'}>
                        <Input/>
                    </Form.Item>
                    {(props.system === '美年' || props.system === '新美年') && (
                        <>
                            <Form.Item label={'appKey'} name={'appKey'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'secret'} name={'secret'}>
                                <Input/>
                            </Form.Item>
                        </>
                    )}
                    {props.system === '云医购' && (
                        <>
                            <Form.Item label={'appKey'} name={'appKey'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'secret'} name={'secret'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'接口Token'} name={'token'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'接口盐'} name={'salt'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'Api Version'} name={'apiVersion'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'供应商编号'} name={'supplierNo'}>
                                <Input/>
                            </Form.Item>
                            <Form.Item label={'供应商名称'} name={'supplierName'}>
                                <Input/>
                            </Form.Item>
                        </>
                    )}
                    <Form.Item label={'预留字段1'} name={'extra1'}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label={'预留字段2'} name={'extra2'}>
                        <Input/>
                    </Form.Item>
                    <div style={{textAlign: "center"}}>
                        <Button type={"primary"} loading={loading} htmlType={'submit'}>保存</Button>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default ExternalConfig
